function SuccessTickIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 26 26">
      <path
        fill="#20BF6B"
        fillRule="evenodd"
        d="M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13zm6.024-15.101a1.625 1.625 0 10-2.298-2.298l-5.351 5.35-2.1-2.1a1.625 1.625 0 10-2.3 2.298l3.251 3.25a1.625 1.625 0 002.298 0l6.5-6.5z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default SuccessTickIcon;
